import axios from "../instance";

export default {
    getAll: () => {
        return axios.api.get("/users/getAllCompany").then((response) => response.data);
    },
    getAllCompanies: (companyId) => {
        if (companyId) {
            return axios.api.get(`/companies?id=${companyId}`).then((response) => response.data);
        } else {
            return axios.api.get("/companies").then((response) => response.data);
        }
    },
    getOne: (id) => {
        return axios.api.get(`/companies/${id}`).then((response) => response.data);
    },
    search: (body) => {
        return axios.api.post("/companies/search", body).then((response) => response.data);
    },
    create: (body) => {
        return axios.api.post("/companies", body).then((response) => response.data);
    },
    update: (id, body) => {
        return axios.api.put(`/companies/${id}`, body).then((response) => response.data);
    },
    delete: (id) => {
        return axios.api.delete(`/companies/${id}`).then((response) => response.data);
    },
    upload: (formData, auth) => {
        return axios.api.post("/files/formData", formData, auth).then((response) => response.data);
    },
    getRunning: (requestType) => {
        return axios.api.get(`/runningNumbers?requestType=${requestType}`).then((response) => response.data);
    }
};
// bank_no
// bank_name
// bank_account_name
// payment_img
